import {
  FETCH_ALL_EXCLUDED_DOMAINS_STARTED,
  FETCH_EXCLUDED_DOMAINS_FAILED,
} from '../types'

export default function isLoading(state = false, { type }) {
  if (type === FETCH_EXCLUDED_DOMAINS_FAILED) return true
  if (type === FETCH_ALL_EXCLUDED_DOMAINS_STARTED) return false
  return state
}
